import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const changeLogModule = {
  namespaced: true,
  state() {
    return {
      entries: [],
      lastEvaluatedKey: null,
    };
  },
  actions,
  mutations,
  getters,
};

export default changeLogModule;
